import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/petrolpump-theme.css';
import './styles/app-responsive.css';
import './styles/unified-design-system.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);














